<iframe (load)="onLoad()" [src]="url$ | async" data-cy="iframe"></iframe>
<div *ngIf="isLoad" class="loader">
  <nz-spin></nz-spin>
</div>
